import React from 'react';
import { Skeleton, Stack, Flex, Grid, SkeletonCircle, Box, SkeletonText } from '@chakra-ui/react';
const HomeSkeleton = () => {
	return (
		<Grid
			mt={6}
			templateColumns="repeat(4, 1fr)"
			sx={{ gap: '30px' }}
			justifyContent={'space-between'}
			flexWrap={'wrap'}
		>
			{[0, 0, 0, 0, 0, 0, 0, 0].map((el, index) => (
				<Box
					key={'box-' + index}
					d="flex"
					border="1px solid #CBD5E0"
					borderRadius={'8px'}
					py={2}
					px={3}
					colSpan={2}
					rowSpan={2}
					flexDirection="column"
					maxW={'330px'}
					h="290px"
					w={'100%'}
				>
					<Skeleton margin="0 auto" width={'60%'} flexBasis="55%"></Skeleton>
					<Stack justifyContent="center" spacing={3} flexBasis="45%">
						<SkeletonText mt={3} noOfLines={2} spacing={3} />
						<Box d="flex" alignItems="center">
							<SkeletonCircle size="6" />
							<Skeleton margin="0 auto" height={'10px'} width={'60%'} flexBasis="80%"></Skeleton>
						</Box>
					</Stack>
				</Box>
			))}
		</Grid>
	);
};

export default HomeSkeleton;
